import interceptor from "@/plugins/interceptor";

export default {
  state: () => ({}),
  mutations: {},
  actions: {
    async forum_forums(_, contentGuid) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_FORUM_URL}/Forums/${contentGuid}`
      );
    },
    async forum_comments(_, params) {
      const { courseId, headerId, pageNumber, rowsPerPage } = params;
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Forums/courses/${courseId}/comments/${headerId}/?pageNumber=${pageNumber}&rowsPerPage=${rowsPerPage}`
      );
    },
    async forum_postComment(_, model) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}/Forums/CreateComment`,
        model
      );
    },
    async forum_deleteComment(_, params) {
      const { commentId, deleteAll, courseId } = params;
      return await interceptor.authenticate.delete(
        `${
          process.env.VUE_APP_API_LMS_URL
        }/Forums/${commentId}?courseId=${courseId}${
          deleteAll ? "&fullDelete=true" : ""
        }`
      );
    },
    async forum_editComment(_, model) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_FORUM_URL}/Comments`,
        model
      );
    },
    async forum_commentAnswers(_, params) {
      const { courseId, commentId, pageNumber = "", rowsPerPage = "" } = params;
      return await interceptor.authenticate.get(
        `${
          process.env.VUE_APP_API_LMS_URL
        }/Forums/courses/${courseId}/answers/${commentId}?pageNumber=${pageNumber || 0}&rowsPerPage=${rowsPerPage}`
      );
    },
    async forum_postLikeHeader(_, headerGuid) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_FORUM_URL}/Likes/headers/${headerGuid}`
      );
    },
    async forum_deleteLikeHeader(_, headerGuid) {
      return await interceptor.authenticate.delete(
        `${process.env.VUE_APP_API_LMS_FORUM_URL}/Likes/headers/${headerGuid}`
      );
    },
    async forum_postLikeComment(_, commentId) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_FORUM_URL}/Likes/comments/${commentId}`
      );
    },
    async forum_deleteLikeComment(_, commentId) {
      return await interceptor.authenticate.delete(
        `${process.env.VUE_APP_API_LMS_FORUM_URL}/Likes/comments/${commentId}`
      );
    },

    /* Only for tutors */
    async forum_postHeader(_, model) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}/Forums/headers`,
        model
      );
    },
    async forum_editHeader(_, model) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}/Forums/headers`,
        model
      );
    },
    async commentsWalls_get(_, params) {
      const courseId = params.courseId;
      const contentIdentifier = params.contentIdentifier;
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${courseId}/CommentsWalls/${contentIdentifier}`
      );
    }
  },
};
